//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        select_view_id () {
            return `item-${this.selected}`
        }
    },
    methods: {
        select (index) {
            this.$emit('change', index)
            this.$emit('hide')
        },
        hide () {
            this.$emit('hide')
        }
    },
    props: {
        show: {
            type: Boolean,
            default () {
                return false
            }
        },
        options: {
            type: Array,
            default () {
                return []
            }
        },
        selected: {
            type: [Number, String]
        }
    }
}
